import { motion } from "framer-motion";
import { toast } from "sonner";
import { LogoMark } from "@/components/Logo";

const EASE = [0.16, 1, 0.3, 1];

const COLUMNS = [
  {
    links: [
      { label: "Hub", href: "/" },
      { label: "AI", href: "/ai" },
      { label: "Factory", href: "/factory" },
      { label: "Stories", href: "/stories" },
      { label: "Careers", href: "/careers" },
      { label: "About", href: "/#about" },
    ],
  },
  {
    links: [
      { label: "LinkedIn", href: "#" },
      { label: "YouTube", href: "#" },
      { label: "Instagram", href: "#" },
      { label: "TikTok", href: "#" },
      { label: "X", href: "#" },
    ],
  },
  {
    links: [
      { label: "Terms of Use", href: "#" },
      { label: "Privacy & Cookies", href: "#" },
      { label: "Press", href: "/stories" },
      { label: "Support", href: "#" },
    ],
  },
  {
    links: [{ label: "Investor Relations", href: "#" }],
  },
];

export const Footer = () => (
  <footer className="pt-24 lg:pt-32 pb-10 bg-white" data-testid="footer">
    <div id="pilot" className="text-center max-w-2xl mx-auto px-6">
      <motion.h2
        initial={{ opacity: 0, y: 32 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 1, ease: EASE }}
        className="font-display font-semibold tracking-tight text-[#3A3A3C] text-3xl sm:text-4xl leading-[1.15]"
      >
        Bring SANTELQ to your facility.
      </motion.h2>

      <motion.div
        initial={{ opacity: 0, y: 32 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 1, ease: EASE, delay: 0.12 }}
        className="mt-9 flex flex-col items-center gap-4"
      >
        <button
          onClick={() => toast("Pre-orders open soon — $300 deposit, fully refundable.")}
          data-testid="footer-preorder-btn"
          className="rounded-full bg-[#0D0D0E] text-white text-sm font-medium px-8 py-3.5 hover:bg-[#1B2A4A] transition-colors duration-300"
        >
          Pre-Order Now
        </button>
        <p className="text-xs text-[#808080]" data-testid="deposit-note">
          $300 deposit — fully refundable.
        </p>
      </motion.div>
    </div>

    <div className="max-w-[1400px] mx-auto px-6 sm:px-12 mt-32 pt-4">
      <div className="grid grid-cols-2 md:grid-cols-6 gap-10" data-testid="footer-sitemap">
        <div className="col-span-2">
          <a href="/" data-testid="footer-logo-link" aria-label="SANTELQ home">
            <LogoMark className="w-8 h-8" />
          </a>
        </div>
        {COLUMNS.map((col, ci) => (
          <div key={ci} className="flex flex-col gap-4">
            {col.links.map((l) => (
              <a
                key={l.label}
                href={l.href}
                data-testid={`footer-link-${l.label.toLowerCase().replace(/[\s&]+/g, "-")}`}
                className="text-[11px] font-medium uppercase tracking-[0.18em] text-[#808080] hover:text-[#3A3A3C] transition-colors duration-300"
              >
                {l.label}
              </a>
            ))}
          </div>
        ))}
      </div>
      <p className="mt-20 text-[11px] text-[#808080]" data-testid="footer-copyright">
        SANTELQ © 2026
      </p>
    </div>
  </footer>
);
